import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiClient from "@/modules/request.module.v2";
import { notify } from "@/components/framework/notify";
import i18n from "@/i18n";

const useChangeSubscriptionPlan = (companyId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["changeSubscriptionPlan", companyId],
    mutationFn: ({ planId }) => {
      return apiClient.post(
        `subscriptions/change-plan`,
        { planId },
        { params: { companyId } },
      );
    },
    onSuccess: (mutationResponse) => {
      queryClient.setQueryData(["subscription", companyId], mutationResponse);
      queryClient.invalidateQueries(["subscriptionHelper", companyId]);

      notify(
        "success",
        i18n.t("subscriptions.notifications.success.subscription_updated"),
      );
    },
    onError: () => {
      notify("error", i18n.t("generic.unknown_error"));
    },
  });
};

export { useChangeSubscriptionPlan };
